import React from "react";
import { useContactus } from "../../redux/hooks/hooks";
import { urlFor } from "../../api/sanity/utils";
import { logo } from "../../assets";

const WatermarkBackground = ({ children }) => {
  const data = useContactus();

  const logoUrl = data?.logo ? urlFor(data?.logo).fit("max").url() : logo;

  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      {/* Arrière-plan avec le logo en filigrane centré */}
      <div
        className="fixed inset-0 opacity-10 pointer-events-none"
        style={{
          backgroundImage: `url(${logoUrl})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundSize: '30%',
        }}
      />

      {/* Overlay pour améliorer la lisibilité */}
      <div className="absolute inset-0 bg-white/80 pointer-events-none" />

      {/* Contenu principal */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default WatermarkBackground;